<div class="container-fluid d-flex flex-column text-center">
    <div class="row">
        <label for="Empieza">Empieza En</label>
    </div>
    <div class="row w-50 m-auto numeros">
        <div class="col-3">
            {{time.days}}
        </div>
        <div class="col-3">
            {{time.hours}}
        </div>
        <div class="col-3">
            {{time.minutes}}
        </div>
        <div class="col-3">
            {{time.seconds}}
        </div>
    </div>
    <div class="row w-50 m-auto">
        <div class="col-3">
            Días
        </div>
        <div class="col-3">
            Horas
        </div>
        <div class="col-3">
            Minutos
        </div>
        <div class="col-3">
            Segundos
        </div>
    </div>
</div>